import React, {useRef, useState} from 'react';
import {Button} from 'antd';
import './index.css';
import {formatCurrencyByLocalChapter} from '../../../Util/commonUtility';
import useLocalization from '../../../Localization';

const CartConfirmationAction = ({
  heading,
  price,
  onPay,
  isJobEditing,
  isAdEditing,
}) => {
  const {ApplicationString} = useLocalization();
  const [isPaying, setIsPaying] = useState(false);
  const isPayingRef = useRef(false);

  const handlePay = async () => {
    if (isPayingRef.current || isJobEditing || isAdEditing) return;
    isPayingRef.current = true;
    setIsPaying(true);
    try {
      await onPay?.();
    } finally {
      isPayingRef.current = false;
      setIsPaying(false);
    }
  };

  return (
    <div className='confirmation-cart-container'>
      <div className='confirmation-content'>
        <div className='confirmation-heading'>{heading}</div>
        <div className='confirmation-price'>
          {formatCurrencyByLocalChapter(price)}
        </div>
      </div>
      <div className='confirmation-buttons'>
        <Button
          type='primary'
          prefixCls='confirmation-payment'
          onClick={handlePay}
          loading={isPaying}
          disabled={isPaying || isJobEditing || isAdEditing}>
          {ApplicationString['userJobsComponent.submit&CheckoutText']}
        </Button>
        {/* <Button prefixCls='confirmation-cancel'>Cancel</Button> */}
      </div>
    </div>
  );
};

export default CartConfirmationAction;
